
document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('#search-input-label');
  const searchLabel = searchInput ? searchInput : document.querySelector('.search__input');
  
  const typingSpeed = searchLabel.dataset.typingSpeed || 100;
  const deletingSpeed = searchLabel.dataset.deletingSpeed || 60;
  const delayAfterDeleting = searchLabel.dataset.delayAfterDeleting || 500;
  const delayBeforeFirstDelete = searchLabel.dataset.delayBeforeFirstDelete || 2000;
  const delayAfterWordTyped = searchLabel.dataset.delayAfterWordTyped || 2400;
  const placeholders = [];

  if (searchLabel.placeholder) {
    placeholders.push(searchLabel.placeholder);
  }

  if (searchLabel.dataset.placeholderTwo) {
    placeholders.push(searchLabel.dataset.placeholderTwo);
  }

  if (searchLabel.dataset.placeholderThree) {
    placeholders.push(searchLabel.dataset.placeholderThree);
  }

  const typeInNextPlaceholder = async (placeholder) => {
    await new Promise((resolve) => {
      let currentPlaceholder = searchLabel.getAttribute('placeholder-label') || '';
      let nextPlaceholder = (currentPlaceholder.length >= 3 && placeholder.startsWith(currentPlaceholder))
        ? placeholder.replace(currentPlaceholder, '')
        : placeholder;

      const typingIntervalId = setInterval(() => {
        currentPlaceholder = searchLabel.getAttribute('placeholder-label') || '';
        searchLabel.setAttribute('placeholder-label', currentPlaceholder + nextPlaceholder.charAt(0));
        if (searchInput) {
          searchLabel.innerHTML = currentPlaceholder + nextPlaceholder.charAt(0);
        }
        if (nextPlaceholder.length === 1) {
          resolve();
          clearInterval(typingIntervalId);
        } else {
          nextPlaceholder = nextPlaceholder.substring(1);
        }
      }, typingSpeed);
    });
  };

  const deleteCurrentPlaceholder = async (nextPlaceholder) => {
    await new Promise((resolve) => {
      let prevPlaceholder = searchLabel.getAttribute('placeholder-label') || '';
      const deletionIntervalId = setInterval(() => {
        const newPlaceholder = prevPlaceholder.substring(0, prevPlaceholder.length - 1);
        searchLabel.setAttribute('placeholder-label', newPlaceholder);
        if (searchInput) {
          searchLabel.innrHTML = newPlaceholder;
        }
        prevPlaceholder = newPlaceholder;
        if (prevPlaceholder.length === 0 || (prevPlaceholder.length >= 3 && nextPlaceholder.startsWith(prevPlaceholder))) {
          resolve();
          clearInterval(deletionIntervalId);
        }
      }, deletingSpeed);
    });
  };

  let startIndex = 0;
  const showNextPlaceholder = () => {
    startIndex = (startIndex + 1) % placeholders.length;
    const nextPlaceholder = placeholders[startIndex];
    deleteCurrentPlaceholder(nextPlaceholder).then(() => {
      setTimeout(() => {
        typeInNextPlaceholder(nextPlaceholder).then(() => {
          setTimeout(showNextPlaceholder, delayAfterWordTyped);
        });
      }, delayAfterDeleting);
    });
  };

  setTimeout(showNextPlaceholder, delayBeforeFirstDelete);
});